import { convertFieldValueAvroToJson } from 'rpc-client-utils';
import { getToolUseIdForResult } from '../utils/chatHelpers';
export function reduceTools(state, action) {
  switch (action.type) {
    case 'TOOL_USE_DETECTED':
      {
        const activeTools = action.blocks.map(b => ({
          toolUseId: getToolUseIdForResult(b),
          toolName: b.name,
          input: convertFieldValueAvroToJson(b.input),
          status: 'pending'
        }));
        return Object.assign({}, state, {
          activeTools,
          pendingToolResults: new Map(),
          pendingApprovals: new Map(),
          status: 'AWAITING_TOOL'
        });
      }
    case 'TOOL_APPROVAL_REQUIRED':
      {
        const activeTools = action.blocks.map(b => ({
          toolUseId: getToolUseIdForResult(b),
          toolName: b.name,
          input: convertFieldValueAvroToJson(b.input),
          status: 'pending'
        }));
        return Object.assign({}, state, {
          activeTools,
          pendingApprovals: new Map(),
          status: 'AWAITING_APPROVAL'
        });
      }
    case 'TOOL_RESULT_SET':
      {
        const nextResults = new Map(state.pendingToolResults);
        nextResults.set(action.toolUseId, action.result);
        const activeTools = state.activeTools.map(t => t.toolUseId === action.toolUseId ? Object.assign({}, t, {
          status: action.status,
          result: 'content' in action.result ? action.result : {
            content: action.result.message
          }
        }) : t);
        return Object.assign({}, state, {
          pendingToolResults: nextResults,
          activeTools
        });
      }
    case 'TOOL_APPROVAL_SET':
      {
        const nextApprovals = new Map(state.pendingApprovals);
        nextApprovals.set(action.toolUseId, Object.assign({
          toolUseId: action.toolUseId,
          approved: action.approved
        }, action.denialFeedback !== undefined ? {
          denialFeedback: action.denialFeedback
        } : {}));
        return Object.assign({}, state, {
          pendingApprovals: nextApprovals
        });
      }
    case 'TOOL_STATUS_UPDATED':
      {
        const activeTools = state.activeTools.map(t => t.toolUseId === action.toolUseId ? Object.assign({}, t, action.update) : t);
        return Object.assign({}, state, {
          activeTools
        });
      }
    case 'TOOL_CLEAR':
      return Object.assign({}, state, {
        activeTools: [],
        pendingToolResults: new Map(),
        pendingApprovals: new Map()
      });
    case 'RESET':
      return Object.assign({}, state, {
        activeTools: [],
        pendingToolResults: new Map(),
        pendingApprovals: new Map(),
        cancelled: false
      });
    default:
      return state;
  }
}